// Array of all human images from people folder (PNG and JPG) - only existing files
const localHumanImages = [
  require("../assets/people/shelly.png"),
  require("../assets/people/debby.png"),
  require("../assets/people/cindy.png"),
  require("../assets/people/raisa.png"),
  require("../assets/people/alby.png"),
  require("../assets/people/zina.png"),
  require("../assets/people/woman1.jpg"),
  require("../assets/people/woman2.jpg"),
  require("../assets/people/man1.jpg"),
  require("../assets/people/man2.jpg"),
  require("../assets/people/woman3.jpg"),
  require("../assets/people/woman4.jpg"),
  require("../assets/people/woman7.jpg"),
  require("../assets/people/man4.jpg"),
  require("../assets/people/man5.jpg"),
];

// Map profile_pic names to actual image files
const profilePicMap = {
  "shelly.png": require("../assets/people/shelly.png"),
  "debby.png": require("../assets/people/debby.png"),
  "cindy.png": require("../assets/people/cindy.png"),
  "raisa.png": require("../assets/people/raisa.png"),
  "alby.png": require("../assets/people/alby.png"),
  "zina.png": require("../assets/people/zina.png"),
  "woman1.jpg": require("../assets/people/woman1.jpg"),
  "woman2.jpg": require("../assets/people/woman2.jpg"),
  "woman3.jpg": require("../assets/people/woman3.jpg"),
  "woman4.jpg": require("../assets/people/woman4.jpg"),
  "woman5.jpg": require("../assets/people/woman5.jpg"),
  "woman6.jpg": require("../assets/people/woman6.jpg"),
  "woman7.jpg": require("../assets/people/woman7.jpg"),
  "man1.jpg": require("../assets/people/man1.jpg"),
  "man2.jpg": require("../assets/people/man2.jpg"),
  "man3.jpg": require("../assets/people/man3.jpg"),
  "man4.jpg": require("../assets/people/man4.jpg"),
  "man5.jpg": require("../assets/people/man5.jpg"),
};

// Function to get image from profile_pic field
export const getProfileImage = (profilePic) => {
  // Replace man3 with man4 and woman5 with woman4
  let actualProfilePic = profilePic;
  if (profilePic === "man3.jpg") {
    actualProfilePic = "man4.jpg";
  } else if (profilePic === "woman5.jpg") {
    actualProfilePic = "woman4.jpg";
  }

  if (actualProfilePic && profilePicMap[actualProfilePic]) {
    return profilePicMap[actualProfilePic];
  }
  // Fallback to random image if profile_pic is not found
  return localHumanImages[Math.floor(Math.random() * localHumanImages.length)];
};

// Function to get image with specific styling and replacements
export const getProfileImageWithStyle = (profilePic) => {
  // Replace man3 with man4 and woman5 with woman4
  let actualProfilePic = profilePic;
  if (profilePic === "man3.jpg") {
    actualProfilePic = "man4.jpg";
  } else if (profilePic === "woman5.jpg") {
    actualProfilePic = "woman4.jpg";
  }

  if (actualProfilePic && profilePicMap[actualProfilePic]) {
    return {
      src: profilePicMap[actualProfilePic],
      style: {}
    };
  }
  
  // Fallback to random image if profile_pic is not found
  return {
    src: localHumanImages[Math.floor(Math.random() * localHumanImages.length)],
    style: {}
  };
};

// Original getImages function for other modules - now uses persistent assignments
export const getImages = (name, image = null) => {
  // If a specific image is provided, use it
  if (image) {
    return image;
  }
  
  // If this agent already has an image assigned, return it (for consistency across screens)
  if (agentImageAssignments.has(name)) {
    return agentImageAssignments.get(name);
  }
  
  // Find an unused image (not assigned to any agent)
  const usedImages = Array.from(agentImageAssignments.values());
  const availableImages = localHumanImages.filter(img => !usedImages.includes(img));
  
  // If all images are used, reset assignments and start fresh
  if (availableImages.length === 0) {
    agentImageAssignments.clear();
    availableImages.push(...localHumanImages);
  }
  
  // Select a random image from available ones
  const randomImage = availableImages[Math.floor(Math.random() * availableImages.length)];
  
  // Assign this image to the agent permanently
  agentImageAssignments.set(name, randomImage);
  
  return randomImage;
};

// Persistent image assignments for LoadMyAgents
let agentImageAssignments = new Map();

// Function specifically for LoadMyAgents - now just calls getImages for consistency
export const getRandomImagesForLoadMyAgents = (agentSlug) => {
  return getImages(agentSlug);
};
